<div class="login-wrapper">
  <div class="login-container">
    <!-- Logo/Header -->
    <div class="login-header">
      <h1 class="login-title">{{ 'resetPassword.title' | transloco }}</h1>
      <p class="login-subtitle" *ngIf="tokenStatus === TokenStatus.VALID && !isSuccess">{{ 'resetPassword.subtitle' | transloco }}</p>
    </div>

    <!-- Loading State -->
    <div *ngIf="tokenStatus === TokenStatus.LOADING" class="status-message">
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
      <p class="status-text">{{ 'resetPassword.validatingLink' | transloco }}</p>
    </div>

    <!-- Valid Token - Show Form -->
    <form *ngIf="tokenStatus === TokenStatus.VALID && !isSuccess" (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label for="newPassword" class="form-label">
          <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
          {{ 'resetPassword.newPassword' | transloco }}
        </label>
        <input
          id="newPassword"
          type="password"
          class="form-input"
          [(ngModel)]="newPassword"
          name="newPassword"
          [placeholder]="'resetPassword.newPasswordPlaceholder' | transloco"
          [class.error]="newPasswordError"
          [disabled]="isLoading"
          required />
        <span *ngIf="newPasswordError" class="error-message">{{ newPasswordError }}</span>
      </div>

      <div class="form-group">
        <label for="confirmPassword" class="form-label">
          <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          {{ 'resetPassword.confirmPassword' | transloco }}
        </label>
        <input
          id="confirmPassword"
          type="password"
          class="form-input"
          [(ngModel)]="confirmPassword"
          name="confirmPassword"
          [placeholder]="'resetPassword.confirmPasswordPlaceholder' | transloco"
          [class.error]="confirmPasswordError"
          [disabled]="isLoading"
          required />
        <span *ngIf="confirmPasswordError" class="error-message">{{ confirmPasswordError }}</span>
      </div>
  
      <button type="submit" class="btn btn-primary btn-submit" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{ 'resetPassword.submit' | transloco }}</span>
        <span *ngIf="isLoading">{{ 'resetPassword.submitting' | transloco }}</span>
        <svg *ngIf="!isLoading" class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
        </svg>
      </button>

      <button type="button" (click)="goToLogin()" class="btn btn-link" [disabled]="isLoading">
        {{ 'forgotPassword.backToLogin' | transloco }}
      </button>
    </form>

    <!-- Success Message - Só aparece se a chamada à API for bem-sucedida -->
    <div *ngIf="isSuccess" class="success-message">
      <svg class="success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="success-text">{{ 'resetPassword.successText' | transloco }}</p>
      <div class="success-link-container">
        <a (click)="goToLogin()" class="success-link">{{ 'forgotPassword.backToLogin' | transloco }}</a>
      </div>
    </div>

    <!-- Error States -->
    <div *ngIf="(tokenStatus === TokenStatus.EXPIRED || tokenStatus === TokenStatus.USED || tokenStatus === TokenStatus.INVALID) && !isSuccess" class="status-message error">
      <svg class="status-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="status-text">{{ tokenStatusMessage }}</p>
      <div class="error-actions">
        <button type="button" (click)="goToForgotPassword()" class="btn btn-primary">
          {{ 'resetPassword.requestNewLink' | transloco }}
        </button>
        <a (click)="goToLogin()" class="error-link">{{ 'forgotPassword.backToLogin' | transloco }}</a>
      </div>
    </div>
  </div>
  <ngx-spinner [size]="'medium'" type="ball-grid-pulse"></ngx-spinner>
</div>
